export class ScholarshipServiceInternalError extends Error {
	public constructor() {
		super('An internal error occured while processing the request');
	}
}
